var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockchain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 52H16C13.8 52 12 53.8 12 56V80C12 82.2 13.8 84 16 84H80C82.2 84 84 82.2 84 80V56C84 53.8 82.2 52 80 52ZM28 76C23.6 76 20 72.4 20 68C20 63.6 23.6 60 28 60C32.4 60 36 63.6 36 68C36 72.4 32.4 76 28 76ZM80 12H16C13.8 12 12 13.8 12 16V40C12 42.2 13.8 44 16 44H80C82.2 44 84 42.2 84 40V16C84 13.8 82.2 12 80 12ZM28 36C23.6 36 20 32.4 20 28C20 23.6 23.6 20 28 20C32.4 20 36 23.6 36 28C36 32.4 32.4 36 28 36Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchain);
export default __webpack_public_path__ + "static/media/blockchain.40e32faac5169d5362222a8b48bd807f.svg";
export { ForwardRef as ReactComponent };